import type { CompositionV3Filters } from '@revelio/data-access';

import {
  isRoleTaxonomyLevelId,
  ROLE_LEVEL_ID_TO_FILTER_KEY,
} from './role-skill-ent-kind';

/**
 * Converts Top-N chart `primarySelections` entries (`{ role_k7: [1] }`, `{ company: [2] }`, …)
 * into `CompositionV3Filters` patches.
 */
export const mergeTopNPrimarySelectionIntoV3Filters = (
  base: CompositionV3Filters,
  primarySelection: Record<string, number[] | undefined>
): CompositionV3Filters => {
  return Object.entries(primarySelection).reduce((acc, [levelId, values]) => {
    if (!values?.length) return acc;

    if (levelId === 'company') {
      return { ...acc, company: [...(acc.company ?? []), ...values] };
    }
    if (levelId === 'region') {
      return { ...acc, region: [...(acc.region ?? []), ...values] };
    }
    if (levelId === 'country') {
      return { ...acc, country: [...(acc.country ?? []), ...values] };
    }
    if (levelId === 'msa') {
      return { ...acc, msa: [...(acc.msa ?? []), ...values] };
    }
    if (levelId === 'state') {
      return { ...acc, state: [...(acc.state ?? []), ...values] };
    }
    if (levelId === 'city') {
      return { ...acc, city: [...(acc.city ?? []), ...values] };
    }
    if (levelId === 'rics_k10') {
      return { ...acc, rics_k10: [...(acc.rics_k10 ?? []), ...values] };
    }
    if (levelId === 'rics_k50') {
      return { ...acc, rics_k50: [...(acc.rics_k50 ?? []), ...values] };
    }
    if (levelId === 'rics_k400') {
      return { ...acc, rics_k400: [...(acc.rics_k400 ?? []), ...values] };
    }

    if (isRoleTaxonomyLevelId(levelId)) {
      const roleKey = ROLE_LEVEL_ID_TO_FILTER_KEY[levelId];
      const prev = acc[roleKey];
      const list = Array.isArray(prev) ? prev : [];
      return {
        ...acc,
        [roleKey]: [...list, ...values],
      };
    }

    return acc;
  }, base);
};
